module.exports = __webpack_public_path__ + "img/post-24.6b9aaedd.jpg";